// import * as utils from "./utils";
// import {$} from './dom'
// import { MessageBoxComponent } from "../components/messageBox/MessageBox.component";
import { DEFAULT_OPTIONS } from "~/shared/configs/qform-options";
class Transporter {
  constructor(url, settings) {
    typeof url === "string" ? this.url = url : this.url = "";
    this.options = settings.options ? {
      ...DEFAULT_OPTIONS,
      ...settings.options
    } : DEFAULT_OPTIONS;
    this.originalBody = settings.body;
    this.body = settings.body ? this.makeUri(settings.body) : this.makeUri({});
    this.params = settings.params ? settings.params : {};
    this.callback = settings.callback ? settings.callback : data => {/* // console.log(data) */};
    this.callbackError = settings.callbackError ? settings.callbackError : this.fnCallBackError;
    this.formId = settings.body ? settings.body.formId || null : null;
    this.onprogress = settings.onprogress ? settings.onprogress : data => {/* // console.log(data) */};
    this.onerror = settings.onerror ? settings.onerror : () => {};
    this.decode = settings.options.decode || false;
  }
  async loadModule() {
    this.Utils = await import(/* webpackChunkName: "utils" */
    './utils').then(data => {
      return data.default;
    });
    this.$ = await import(/* webpackChunkName: "dom" */
    './dom').then(data => {
      return data.$;
    });
  }
  checkIE8_9() {
    return !!navigator.userAgent.match(/(MSIE 9\.0)|(MSIE 8\.0)/);
  }
  xhrRequest() {
    let a = this.checkIE8_9();
    const b = [function () {
      return a ? new XDomainRequest() : new XMLHttpRequest();
    }, function () {
      return new ActiveXObject("Msxml2.XMLHTTP");
    }, function () {
      return new ActiveXObject("Msxml3.XMLHTTP");
    }, function () {
      return new ActiveXObject("Microsoft.XMLHTTP");
    }];
    for (let i = 0; i < b.length; i++) {
      try {
        a = b[i]();
      } catch (a) {
        continue;
      }
      break;
    }
    return a;
  }
  makeUri(object) {
    return Object.entries(object).map(_ref => {
      let [key, value] = _ref;
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }).join("&");
  }
  fnCallBackError(xhr) {
    if (window.IdFormsList) {
      let messageBoxList = [];
      let response;
      if (!xhr.response) {
        response = {
          title: 'Внимание!',
          messages: 'Спасибо за внимание'
        };
      } else {
        response = {
          title: xhr.response.title,
          messages: xhr.response.messages
        };
      }
      if (this.formId) {
        let $root = document.querySelector('[data-formid="' + this.formId + '"]');
        let ellMessageBox = $root ? $root.querySelector('.message-box') : null;

        // if(!ellMessageBox) {
        //   let $el = this.$.create("div", MessageBoxComponent.className);
        //   $root.prepend($el.$el)
        //   let MessageBox = new MessageBoxComponent($el, {
        //     title: response.title,
        //     messages: response.messages,
        //     typeId: response.status,
        //     iconClass: "icon-error",
        //     idForm: this.formId
        //   })
        //   $el.clear()
        //   $el.html(MessageBox.toHTML());
        //   MessageBox.init()
        // }
      }

      /* let $el = $.create("div", MessageBoxComponent.className);
      window.IdFormsList.forEach(formId => {
        let $root = document.querySelector('[data-formid="'+formId+'"]');
        let ell = $root.querySelector('.message-box')
        // console.log(ell)
        if(!ell) {
          $root.prepend($el.$el)
        }
        messageBoxList.push({
          messageBox: new MessageBoxComponent($el, {
            title: response.title,
            messages: response.messages,
            typeId: response.status,
            iconClass: "icon-error",
            idForm: window.IdFormsList[0]
          })
        })
      })
      messageBoxList.forEach(x => {
        // console.log($el)
        $el.clear()
        $el.html(x.messageBox.toHTML());
        x.messageBox.init()
      }) */
    }
  }
  post() {
    try {
      let contentType = "application/x-www-form-urlencoded; charset=utf-8";
      let response;
      if (!(response = this.xhrRequest())) return;
      // $protocol
      // this.url = this.url.replace('https', 'http')
      response.open("POST", this.url, true);
      if (this.checkIE8_9()) {
        response.onload = () => {
          if (this.decode) {
            let Base64 = new QFormBase64();
            let res = JSON.parse(Base64.decode(response.responseText));
            this.callback(res);
          } else {
            if (this.Utils.IsJsonString(response.responseText)) {
              let data = JSON.parse(response.responseText);
              this.callback(data);
            } else {
              this.callback(response.responseText);
            }
          }
        };
      } else {
        // response.setRequestHeader("Content-Type", contentType);
        Object.entries(this.options.headers).map(_ref2 => {
          let [key, value] = _ref2;
          response.setRequestHeader(key, value);
        });
        response.onreadystatechange = () => {
          if (response.readyState == 4 && response.status == 200 || response.readyState == XMLHttpRequest.DONE && response.status == 200) {
            if (this.decode) {
              let Base64 = new QFormBase64();
              let res = JSON.parse(Base64.decode(response.responseText));
              this.callback(res);
            } else {
              if (this.Utils.IsJsonString(response.responseText)) {
                let data = JSON.parse(response.responseText);
                this.callback(data);
              } else {
                this.callback(response.responseText);
              }
            }
          } else if (+response.status !== 200) {
            this.callbackError(response);
          }
        };
      }
      response.upload.onprogress = e => {
        this.onprogress({
          loaded: e.loaded,
          total: e.total
        });
      };
      response.onprogress = (event, handler) => {
        if (event.lengthComputable) {
          this.onprogress({
            loaded: event.loaded,
            total: event.total
          });

        } else {
          this.onprogress({
            loaded: event.loaded
          });
 // если в ответе нет заголовка Content-Length
        }
        if (handler) {
          handler();
        }
      };
      response.onerror = e => {
        this.onerror(e);
      };
      if (this.originalBody instanceof FormData) {
        response.send(this.originalBody);
      } else if (this.body.match(/^videowidgetId/)) {
        response.send(JSON.stringify(this.originalBody));
      } else {
        response.send(this.body);
      }
    } catch (error) {
      // console.log('Transporter.post() => ', error)
      // Для кабинета QForm
      let restart = document.querySelectorAll('[data-script_hook_restart]');
      if (restart) {
        for (let i = 0; i < restart.length; i++) {
          restart[i].click();
        }
      } else {
        // console.log('Не нашел хук restart')
      }
    }
  }
  get() {
    try {
      let contentType = "application/x-www-form-urlencoded; charset=utf-8";
      let response;
      if (!(response = this.xhrRequest())) return;
      this.url = new URL(this.url);
      let param = Object.entries(this.params).map(_ref3 => {
        let [key, value] = _ref3;
        return this.Utils.IsJsonString(value) ? `${encodeURIComponent(key)}=${encodeURIComponent(JSON.parse(value))}` : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      }).join("&");
      this.url = `${this.url}?${param}`;
      response.open("GET", this.url, true);
      if (this.checkIE8_9()) {
        response.onload = () => {
          if (this.decode) {
            let Base64 = new QFormBase64();
            let res = JSON.parse(Base64.decode(response.responseText));
            this.callback(res);
          } else {
            if (this.Utils.IsJsonString(response.responseText)) {
              let data = JSON.parse(response.responseText);
              this.callback(data);
            } else {
              this.callback(response.responseText);
            }
          }
        };
      } else {
        Object.entries(this.options.headers).map(_ref4 => {
          let [key, value] = _ref4;
          response.setRequestHeader(key, value);
        });
        response.onreadystatechange = () => {
          if (response.readyState == 4 && response.status == 200 || response.readyState == XMLHttpRequest.DONE && response.status == 200) {
            if (this.decode) {
              let Base64 = new QFormBase64();
              let res = JSON.parse(Base64.decode(response.responseText));
              this.callback(res);
            } else {
              if (this.Utils.IsJsonString(response.responseText)) {
                let data = JSON.parse(response.responseText);
                this.callback(data);
              } else {
                this.callback(response.responseText);
              }
            }
          }
        };
      }
      response.upload.onprogress = e => {
        this.onprogress({
          loaded: e.loaded,
          total: e.total
        });
      };
      // response.onprogress = (event) => {
      // if (event.lengthComputable) {
      // this.onprogress({ loaded: event.loaded, total: event.total });
      // // console.log(`Получено ${event.loaded} из ${event.total} байт`);
      // } else {
      // this.onprogress({ loaded: event.loaded });
      // // console.log(`Получено ${event.loaded} байт`); // если в ответе нет заголовка Content-Length
      // }
      // };
      response.send();
    } catch (error) {
      console.error(error);
      // console.log('Transporter.get() => ', error)
      // Для кабинета QForm
      let restart = document.getElementById('restart');
      if (restart) {
        restart.click();
      } else {
        // console.log('Не нашел хук restart')
      }
    }
  }
}
export function transporter(url) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Transporter(url, settings);
}
transporter.post = async function (url) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let tr = new Transporter(url, settings);
  await tr.loadModule();
  tr.post();
};
transporter.get = async function (url) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let tr = new Transporter(url, settings);
  await tr.loadModule();
  tr.get();
};
class QFormBase64 {
  constructor() {
    this._keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  }
  decode(e) {
    let t = "";
    let n, r, i;
    let s, o, u, a;
    let f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = s << 2 | o >> 4;
      r = (o & 15) << 4 | u >> 2;
      i = (u & 3) << 6 | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = this._utf8_decode(t);
    return t;
  }
  _utf8_decode(e) {
    let t = "";
    let n = 0;
    let r,
      c1,
      c2,
      c3 = 0;
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode((r & 31) << 6 | c2 & 63);
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        n += 3;
      }
    }
    return t;
  }
}